<!-- ============================================================== -->
<!-- Sales chart -->
<!-- ============================================================== -->
<div class="row">
  <!-- New Updates -->
  <div class="col-md-6">
    <!-- card new -->
    <div class="card">
      <div class="card-body">
        <h4 class="card-title m-b-0">News Updates</h4>
      </div>
      <ul class="list-style-none" *ngFor="let bulletin of BulletinItems; let i = index">
        <li *ngIf="i===0; then thenBlock else elseBlock"></li>
        <ng-template #thenBlock>
          <li class="no-block card-body">
            <div class="row">
              <div class="col-md-12">
                <span class="m-b-0 font-medium p-0">{{bulletin.Subject}}</span>
              </div>
              <div class="col-md-12">
                <span class="text-muted">{{bulletin.Contents}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <span class="float-right">{{bulletin.EffectiveDate | date:'yyyy/MM/dd'}}</span>
                <span class="badge badge-pill badge-danger">Important</span>
              </div>
            </div>
          </li>
        </ng-template>
        <ng-template #elseBlock>
          <li class="no-block card-body border-top">
            <div class="row">
              <div class="col-md-12">
                <span class="m-b-0 font-medium p-0">{{bulletin.Subject}}</span>
              </div>
              <div class="col-md-12">
                <span class="text-muted">{{bulletin.Contents}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <span class="float-right">{{bulletin.EffectiveDate | date:'yyyy/MM/dd'}}</span>
                <span class="badge badge-pill badge-danger">Important</span>
              </div>
            </div>
          </li>
        </ng-template>
      </ul>
    </div>
  </div>
  <!-- New Updates end -->
  <div class="col-md-6" *ngIf='showJob'>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title m-b-0">Job History</h4>
      </div>
      <table mat-table [dataSource]="JobHisItems" style="width: 96%;margin-left: 10px;" class="dataTable no-footer">

        <ng-container matColumnDef="Project">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 28px;">Project</th>
          <td mat-cell *matCellDef="let el" style="font-size: 12px;"> {{el.Project}} </td>
        </ng-container>

        <ng-container matColumnDef="Region">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 0px;">Region</th>
          <td mat-cell *matCellDef="let el" style="font-size: 12px;"> {{el.Region}} </td>
        </ng-container>

        <ng-container matColumnDef="StartDate">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 28px;">Start Date</th>
          <td mat-cell *matCellDef="let el" style="font-size: 12px;"> {{el.StartDate.ToDateTimeString()}} </td>
        </ng-container>

        <ng-container matColumnDef="EndDate">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 28px;">End Date</th>
          <td mat-cell *matCellDef="let el" style="font-size: 12px;"> {{el.EndDate != null ?
            el.EndDate.ToDateTimeString() : ''}} </td>
        </ng-container>

        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 10px;">Status</th>
          <td mat-cell *matCellDef="let el" style="font-size: 12px;"> {{el.Status}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
  <div class="col-md-6" *ngIf='false'>
    <!-- Card -->
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">To Do List</h4>
        <div class="todo-widget scrollable" style="height:450px;">
          <ul class="list-task todo-list list-group m-b-0" data-role="tasklist">
            <li class="list-group-item todo-item" data-role="task">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="customCheck">
                <label class="custom-control-label todo-label" for="customCheck">
                  <span class="todo-desc">Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.</span> <span class="badge badge-pill badge-danger float-right">Today</span>
                </label>
              </div>
              <div class="item-date"> 26 jun 2017</div>
            </li>
            <li class="list-group-item todo-item" data-role="task">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="customCheck1">
                <label class="custom-control-label todo-label" for="customCheck1">
                  <span class="todo-desc">Lorem Ipsum is simply dummy text of the printing</span><span
                    class="badge badge-pill badge-primary float-right">1 week </span>
                </label>
              </div>
              <div class="item-date"> 26 jun 2017</div>
            </li>
            <li class="list-group-item todo-item" data-role="task">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="customCheck2">
                <label class="custom-control-label todo-label" for="customCheck2">
                  <span class="todo-desc">Give Purchase report to</span> <span
                    class="badge badge-pill badge-info float-right">Yesterday</span>
                </label>
              </div>
              <div class="item-date"> 26 jun 2017</div>
            </li>
            <li class="list-group-item todo-item" data-role="task">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="customCheck3">
                <label class="custom-control-label todo-label" for="customCheck3">
                  <span class="todo-desc">Lorem Ipsum is simply dummy text of the printing </span>
                  <span class="badge badge-pill badge-warning float-right">2 weeks</span>
                </label>
              </div>
              <div class="item-date"> 26 jun 2017</div>
            </li>
            <li class="list-group-item todo-item" data-role="task">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="customCheck4">
                <label class="custom-control-label todo-label" for="customCheck4">
                  <span class="todo-desc">Give Purchase report to</span> <span
                    class="badge badge-pill badge-info float-right">Yesterday</span>
                </label>
              </div>
              <div class="item-date"> 26 jun 2017</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- ============================================================== -->
<!-- Sales chart -->
<!-- ============================================================== -->
